export default {
  config: {
    originMap: {
      'localhost.ntrs.com:8080': 'local',
      'dev.accountopen.ntrs.com': 'dev',
      'int.accountopen.ntrs.com': 'int',
      'uat.accountopen.ntrs.com': 'uat',
      'uat2.accountopen.ntrs.com': 'uat2',
      'accountopen.ntrs.com': 'prod'
    },
    okta: {
      sessionTimeout: {
        timeUntilOpen: 600,
        refreshFrequency: 600,
        logoutBtnText: 'Sign Out',
        continueBtnText: 'Stay Signed In',
        header: 'Session Expiring Soon',
        content: 'Your current session will expire soon due to inactivity.'
      },
      authenticatedOrigins: [
        'https://localhost.ntrs.com:8080',
        'https://dev.accountopen.ntrs.com',
        'https://int.accountopen.ntrs.com',
        'https://uat.accountopen.ntrs.com',
        'https://uat2.accountopen.ntrs.com',
        'https://accountopen.ntrs.com'
      ],
      blacklist: [''],
      oidc: {
        default: {
          oktaUrl: 'https://loginsys.ntrs.com',
          issuer: 'https://loginsys.ntrs.com/oauth2/ausch0efzA1f3utyx1d6',
          clientId: '0oadbvq1rf1tJIrmF1d7',
          redirectUri: 'https://localhost.ntrs.com:8080/login/callback',
          tokenManager: {
            autoRenew: true,
            autoRemove: true,
            storage: 'sessionStorage'
          }
        },
        local: {
          oktaUrl: 'https://loginsys.ntrs.com',
          issuer: 'https://loginsys.ntrs.com/oauth2/ausch0efzA1f3utyx1d6',
          clientId: '0oadbvq1rf1tJIrmF1d7',
          redirectUri: 'https://localhost.ntrs.com:8080/login/callback',
          tokenManager: {
            autoRenew: true,
            autoRemove: true,
            storage: 'sessionStorage'
          }
        },
        dev: {
          oktaUrl: 'https://loginsys.ntrs.com',
          issuer: 'https://loginsys.ntrs.com/oauth2/ausch0efzA1f3utyx1d6',
          clientId: '0oadbvq1rf1tJIrmF1d7',
          redirectUri: 'https://dev.accountopen.ntrs.com/login/callback',
          tokenManager: {
            autoRenew: true,
            autoRemove: true,
            storage: 'sessionStorage'
          }
        },
        int: {
          oktaUrl: 'https://loginsys.ntrs.com',
          issuer: 'https://loginsys.ntrs.com/oauth2/ausch0efzA1f3utyx1d6',
          clientId: '0oadbv4l75M8EeXWl1d7',
          redirectUri: 'https://int.accountopen.ntrs.com/login/callback',
          tokenManager: {
            autoRenew: true,
            autoRemove: true,
            storage: 'sessionStorage'
          }
        },
        uat: {
          oktaUrl: 'https://loginuat.ntrs.com',
          issuer: 'https://loginuat.ntrs.com/oauth2/austt2ltc0NdZ2J8K0h7',
          clientId: '0oa23849dq1OsS11I0h8',
          redirectUri: 'https://uat.accountopen.ntrs.com/login/callback',
          tokenManager: {
            autoRenew: true,
            autoRemove: true,
            storage: 'sessionStorage'
          }
        },
        uat2: {
          oktaUrl: 'https://loginuat.ntrs.com',
          issuer: 'https://loginuat.ntrs.com/oauth2/austt2ltc0NdZ2J8K0h7',
          clientId: '0oa2386m2pusr6PWO0h8',
          redirectUri: 'https://uat2.accountopen.ntrs.com/login/callback',
          tokenManager: {
            autoRenew: true,
            autoRemove: true,
            storage: 'sessionStorage'
          }
        },
        prod: {
          oktaUrl: 'https://login.ntrs.com',
          issuer: 'https://login.ntrs.com/oauth2/aus1m4yuzpqNFht7o0h8',
          clientId: '0oa1yhfjicr3EQ9mh0h8',
          redirectUri: 'https://accountopen.ntrs.com/login/callback',
          tokenManager: {
            autoRenew: true,
            autoRemove: true,
            storage: 'sessionStorage'
          }
        },
        shared: {
          pkce: true,
          scopes: ['openid', 'profile', 'email', 'aor.role', 'okta.myAccount.profile.read', 'api.read', 'api.write']
        }
      }
    }
  }
};